import React from "react";
import CustomTable from "@/shared/components/ui/Button/CustomTable";

const ContactTableSection = ({
  contacts,
  columns,
  renderCell,
  totalContacts,
  rowsPerPage,
  page,
  onPageChange,
  selectedContacts,
  onSelectionChange,
  groupBy = null,
  groupByFallbackLabel = "(No company)",
  groupSortCompare,
  showSelectAllBanner,
}) => {
  return (
    <div className="mt-2">
      <CustomTable
        renderCell={renderCell}
        columns={columns}
        data={contacts}
        totalCount={totalContacts}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        enableSelection
        // headerColor="bg-white"
        height={`calc(100dvh - ${showSelectAllBanner ? "230px" : "136px"})`}
        onSelectionChange={onSelectionChange}
        selectedItems={selectedContacts}
        pl="pl-2"
        pr="pr-2"
        pinFirstColumn
        showCellBorders
        groupBy={groupBy}
        groupByFallbackLabel={groupByFallbackLabel}
        groupSortCompare={groupSortCompare}
      />
    </div>
  );
};

export default ContactTableSection;
